/* @flow */
import { Set, Record, List, fromJS } from 'immutable';

export type RawOptions = {
  query?: string,
  pageNumber?: number,
  pageSize?: number,
  sortBy?: string,
  sortOrder?: 'ASC' | 'DESC',
};

export const Options = Record({
  query: '',
  pageNumber: 0,
  pageSize: 25,
  sortBy: 'name',
  sortOrder: 'DESC',
});

export type RawWhitelistType = {
  guid: ?string,
  pattern: ?string,
  text: ?string,
  created: ?number,
  updated: ?number,
  updatedBy: ?string,
  createdBy: ?string,
};

export type WhitelistEntryType = Record<RawWhitelistType>;

export const WhitelistEntry = Record({
  guid: '',
  pattern: '',
  text: '',
});

// Like payload action but also supports field to update
export type WhitelistAction<T> = {
  type: string,
  payload: T,
  field?: string,
  error?: boolean,
  meta?: Object,
};

export type WhitelistPageType = {
    pageNumber: number,
    totalPages: number,
    pageSize: number,
    totalElements: number,
    items: Array<WhitelistEntry>,
    empty: boolean,
    hasNext: boolean,
  };

  export const WhitelistPage = (pageObject: WhitelistPageType) => fromJS(pageObject);

  export type WhitelistEntries = List<WhitelistEntryType>;


// WEBPACK FOOTER //
// ./src/app/modules/global-whitelist/types.js